import { NgModule } from '@angular/core';
import { Routes, RouterModule, ExtraOptions, PreloadAllModules } from '@angular/router';
import { AccessGranted } from './guards/access-granted.guard';
import { AccessCodeComponent } from '@components/access-code/access-code.component';
import { CapabilityAccess } from './guards/capability-access.guard';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'order-intake',
  },
  {
    path: 'miami-access',
    component: AccessCodeComponent
  },
  {
    path: 'order-intake',
    loadChildren: () => import('./modules/order-intake/order-intake.module').then( m => m.OrderIntakeModule),
    data: { title: 'order_intake' },
    canActivate: [AccessGranted],
    canMatch: [CapabilityAccess]
  },
  {
    path: 'order-intake-history',
    loadChildren: () => import('./modules/order-intake-history/order-intake-history.module').then(m => m.OrderIntakeHistoryModule),
    data: { title: 'order_intake_history' },
    canActivate: [AccessGranted],
    canMatch: [CapabilityAccess]
  },
  {
    path: 'order-backlog',
    loadChildren: () => import('./modules/order-backlog/order-backlog.module').then(m => m.OrderBacklogModule),
    data: { title: 'order_backlog' },
    canActivate: [AccessGranted],
    canMatch: [CapabilityAccess]
  },
  {
    path: 'production-program',
    loadChildren: () => import('./modules/production-program/production-program.module').then(m => m.ProductionProgramModule),
    data: { title: 'production_program' },
    canActivate: [AccessGranted],
    canMatch: [CapabilityAccess]
  },
  {
    path: 'allocation',
    loadChildren: () => import('./modules/allocation/allocation.module').then(m => m.AllocationModule),
    data: { title: 'allocation' },
    canActivate: [AccessGranted],
    canMatch: [CapabilityAccess]
  },
  {
    path: 'plant-stock',
    loadChildren: () => import('./modules/plant-stock/plant-stock.module').then(m => m.PlantStockModule),
    data: { title: 'plant_stock' },
    canActivate: [AccessGranted],
    canMatch: [CapabilityAccess]
  },
  {
    path: 'deliveries',
    loadChildren: () => import('./modules/deliveries/deliveries.module').then(m => m.DeliveriesModule),
    data: { title: 'deliveries' },
    canActivate: [AccessGranted],
    canMatch: [CapabilityAccess]
  },
  {
    path: 'about',
    loadChildren: () => import('./modules/about/about.module').then(m => m.AboutModule),
    data: { title: 'about' },
    canActivate: [AccessGranted]
  },
  {
    path: 'help',
    loadChildren: () => import('./modules/help/help.module').then(m => m.HelpModule),
    data: { title: 'help' }
  },
  {
    path: '**',   // Fallback route for any unmatched route
    loadChildren: () => import('./modules/help/help.module').then(m => m.HelpModule), // Fallback to help module
    data: { title: 'help' }
  }
];


// Enable route parameters inheritance
export const routingConfiguration: ExtraOptions = {
  paramsInheritanceStrategy: 'always',
  preloadingStrategy: PreloadAllModules,
  useHash: true
};

@NgModule({
  imports: [RouterModule.forRoot(routes, routingConfiguration)],
  providers: [
    AccessGranted,
    CapabilityAccess
  ],
  exports: [RouterModule]
})
export class RoutingModule { }
